var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.9 14.85",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-information-circle",
    className: "cls-1",
    d: "m7.45.11C3.41.11.14,3.38.13,7.42c0,4.04,3.27,7.32,7.31,7.32,4.04,0,7.32-3.27,7.32-7.31h0c0-4.04-3.27-7.32-7.31-7.32Zm.67,10.69h-1.34v-5.06h1.34v5.06Zm-.67-5.62c-.39-.02-.69-.34-.67-.73.02-.39.34-.69.73-.67.38.02.67.32.67.7,0,.39-.31.7-.7.7,0,0-.02,0-.03,0h0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info.80f95bca5e173f538ccd1552be747586.svg";